/*globals $ */

class PhilosophyPcHero {
  constructor(el) {
    this._el = el;
    this._image = el.getElementsByClassName('PhilosophyPcHero__image')[0];
    this._img = el.getElementsByTagName('img')[0];

    this._update = this._update.bind(this);
    this._show = this._show.bind(this);

    window.addEventListener('scroll', this._update);
    window.addEventListener('resize', this._update);
    this._img.addEventListener('load', this._update);
    this._img.addEventListener('load', this._show);
    this._update();
    this._show();
  }

  _update() {
    const bounds = this._el.getBoundingClientRect();
    const offset = window.pageYOffset + bounds.top;
    const minHeight = 300;
    const maxHeight = window.innerHeight * 0.6;
    const height = Math.max(
      Math.min(window.innerHeight - offset, maxHeight),
      minHeight
    );
    this._el.style.height = `${height}px`;

    let ratio = (bounds.top + height) / window.innerHeight;
    ratio = Math.min(ratio, 1);
    ratio = Math.max(ratio, 0);
    const imageY = ratio * (height - this._image.offsetHeight);
    this._image.style.transform = `translate3d(0, ${imageY}px, 0)`;

    if (this._img.complete) {
      const areaWidth = this._img.parentNode.clientWidth;
      const areaHeight = this._img.parentNode.clientHeight;
      const areaRatio = areaWidth / areaHeight;
      const imgWidth = this._img.naturalWidth;
      const imgHeight = this._img.naturalHeight;
      const imgRatio = imgWidth / imgHeight;
      if (imgRatio > areaRatio) {
        this._img.style.width = 'auto';
        this._img.style.height = `${areaHeight}px`;
      } else {
        this._img.style.width = `${areaWidth}px`;
        this._img.style.height = 'auto';
      }
    }
  }

  _show() {
    if (this._img.complete) {
      this._img.removeEventListener('load', this._show);
      this._el.classList.add('PhilosophyPcHero--loaded');
    }
  }
}

class PhilosophyPcStatement {
  constructor(el) {
    this._el = el;

    this._checkPosition = this._checkPosition.bind(this);

    window.addEventListener('scroll', this._checkPosition);
    window.addEventListener('resize', this._checkPosition);
    this._checkPosition();
  }

  _checkPosition() {
    const bounds = this._el.getBoundingClientRect();
    if (bounds.top < window.innerHeight) {
      window.removeEventListener('scroll', this._checkPosition);
      window.removeEventListener('resize', this._checkPosition);
      this._el.classList.add('PhilosophyPcStatement--show');
    }
  }
}

class PhilosophyPcOverlay {
  constructor(el) {
    this._el = el;
    this._slick = el.getElementsByClassName('slick-slider')[0];

    this._close = this._close.bind(this);

    this._el.addEventListener('click', this._close);
    $(this._slick).slick({
      cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      draggable: false,
      infinite: false,
      speed: 700
    });
  }

  open(index = 0) {
    $(this._slick).slick('slickGoTo', index, true);
    this._el.classList.add('PhilosophyPcOverlay--opened');
  }

  _close(e) {
    if (e.target.dataset.overlayClose === 'true') {
      this._el.classList.remove('PhilosophyPcOverlay--opened');
    }
  }
}

class PhilosophyPcItem {
  get el() {
    return this._el;
  }

  constructor(el) {
    this._el = el;

    this._check = this._check.bind(this);

    window.addEventListener('scroll', this._check);
    window.addEventListener('resize', this._check);
    this._check();
  }

  _check() {
    const bounds = this._el.getBoundingClientRect();

    if (bounds.top <= window.innerHeight) {
      window.removeEventListener('scroll', this._check);
      window.removeEventListener('resize', this._check);
      this._el.classList.add('PhilosophyPcItem--show');

      const duration = Math.random() * 1 + 1;
      const delay = Math.random() * 0.3;
      this._el.style.transition = `opacity ${duration}s ${delay}s`;
    }
  }
}

class PhilosophyPc {
  constructor(pageApp) {
    this._pageApp = pageApp;
    this._el = document.getElementsByClassName('PhilosophyPc')[0];
    this._el.classList.add('PhilosophyPc--init');

    this._openOverlay = this._openOverlay.bind(this);

    new PhilosophyPcHero(
      this._el.getElementsByClassName('PhilosophyPcHero')[0]
    );
    this._statement = new PhilosophyPcStatement(
      this._el.getElementsByClassName('PhilosophyPcStatement')[0]
    );
    this._overlay = new PhilosophyPcOverlay(
      this._el.getElementsByClassName('PhilosophyPcOverlay')[0]
    );

    this._items = [...this._el.getElementsByClassName('PhilosophyPcItem')].map(
      (el, index) => {
        const item = new PhilosophyPcItem(el);
        item.el.addEventListener('click', e => {
          e.preventDefault();
          this._openOverlay(index);
        });
        return item;
      }
    );
  }

  _openOverlay(index) {
    this._overlay.open(index);
  }
}

export default PhilosophyPc;
